import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const BarcodeDisplay = ({ value }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current && value) {
      JsBarcode(barcodeRef.current, value, {
        format: 'CODE128',
        displayValue: true,
        fontSize: 18,
        height: 60,
        width: 2,
      });
    }
  }, [value]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
      <svg ref={barcodeRef} title="Wallet Barcode" />
    </div>
  );
};

export default BarcodeDisplay;
